exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".Step2a-5637bb73{max-width:375px;margin:0 auto;text-align:center}.Step2a-5637bb73 h3{margin-bottom:25px}.Step2a-5637bb73 .formArea-a4452d72{max-width:240px;text-align:left;margin:0 auto}.Step2b-e57d4f79{max-width:400px;margin:0 auto}.Step2b-e57d4f79 .numberInput-2c82f577{margin-top:30px}.Step2b-e57d4f79 .error-4fd1ddb6{color:#FF3940}\n", ""]);

// Exports
exports.locals = {
	"Step2a": "Step2a-5637bb73",
	"formArea": "formArea-a4452d72",
	"Step2b": "Step2b-e57d4f79",
	"numberInput": "numberInput-2c82f577",
	"error": "error-4fd1ddb6"
};